import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

interface DoctorDiscountParams {
  hospitalId?: string;
  search?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
}

const getInvoiceDiscountRequestApi = createAsyncThunk(
  'getDoctorDiscount',
  async (params: DoctorDiscountParams = {}, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = params.hospitalId || sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');

      const query = new URLSearchParams();
      if (hospitalId) query.append('hospitalId', hospitalId);
      if (params.search) query.append('search', params.search);
      if (params.fromDate) query.append('fromDate', params.fromDate);
      if (params.toDate) query.append('toDate', params.toDate);    
      if (params.page !== undefined) query.append('page', String(params.page));
      if (params.limit !== undefined) query.append('limit', String(params.limit));

      const url = `${BILLING_ROUTES.DOCTOR_DISCOUNT.invoiceDiscountRequest}?${query.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error);
      }

      return await response.json();
    } catch (error: any) {
      return rejectWithValue({ message: error.message || 'Something went wrong' });
    }
  }
);

export default getInvoiceDiscountRequestApi;